import Vue from 'vue';

const success = (data, context) => {
  const bookings = data.bookings;
  context.bookings = bookings;
  context.totalBookings = data.total;
};

const failed = (error, context) => {
  console.log("gn-fail");
  console.log(error);
  context.messagesLoading = false;
};

export default (context, sortBy, limit = 10, offset = 0, search = null) => {
  return Vue.$http.get('messages/get?sortby='+sortBy+'&limit='+limit+'&offset='+offset+'&search='+search).then((response) => {
    if (response && response.status === 200) {
      success(response.data, context);
    }
  }).catch((error) => {
    failed(error, context);
  }).finally(() => {
    context.loading = false;
  });
};



// WEBPACK FOOTER //
// ./src/app/services/message/get-new.js